import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
import "../../../styles.css";
import Vectorsorting from "../../../assets/Vectorsorting.svg";
import arrowright from "../../../assets/arrowright.svg";
import ShimmerLoader from "../../../loading";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../components/CustomWidgets/CustomPagination";
import { Navigate, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Edit from "../../../assets/Edit.svg";

const AllVendorsTable = ({
  loading,
  additionalData,
  pagination,
  handlePaymentClick,
  onEditLine,
  isSelectMode,
  selectedVendors,
  onToggleSelect,
  onSelectAll,
}) => {
  const { t, i18n } = useTranslation();
  const [flag, setflag] = useState(false);
  const navigate = useNavigate();
  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  )

  const openOrderList = (id) => {
    navigate(`/vendorDetails?id=${id}`);
  };

  const data = useMemo(() => additionalData || [], [additionalData]);

  useEffect(() => {
    if (additionalData?.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setflag(true);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [additionalData, flag]);

  const allSelected =
    data?.length > 0 &&
    data.every((vendor) => selectedVendors?.includes(vendor.id));

  const columns = useMemo(
    () => [
      ...(isSelectMode
        ? [
            {
              id: "select",
              Header: () => (
                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={(e) => onSelectAll && onSelectAll(e.target.checked)}
                  onClick={(e) => e.stopPropagation()}
                  className="cursor-pointer w-4 h-4 accent-[#465466]"
                />
              ),
              width: "50px",
              disableSortBy: true,
              Cell: ({ row }) => (
                <div className="text-start">
                  <input
                    type="checkbox"
                    checked={selectedVendors?.includes(row.original.id)}
                    onChange={() => onToggleSelect && onToggleSelect(row.original.id)}
                    onClick={(e) => e.stopPropagation()}
                    className="cursor-pointer w-4 h-4 accent-[#465466]"
                  />
                </div>
              ),
            },
          ]
        : []),
      {
        Header: t("Vendor Name"),
        accessor: "name",
        width: "180px",
        Cell: ({ row }) => <div className="text-start">{row.original.name}</div>,
      },
      {
        Header: t("Phone Number"),
        accessor: "phone",
        width: "120px",
        Cell: ({ row }) => <div className="text-start">{row.original.phone}</div>,
      },
      {
        Header: t("Create Date"),
        accessor: "create_date",
        width: "160px",
        Cell: ({ row }) => (
          <div className="text-start">{row.original.create_date}</div>
        ),
      },
      {
        Header: t("Current Inventory Value"),
        accessor: "inventory_value",
        width: "160px",
        Cell: ({ row }) => (
          <div className="text-center">{"EGP"} {row.original.inventory_value?.toFixed(2)}</div>
        ),
      },
      {
        Header: t("Current Inventory in Days"),
        accessor: "inventory_days",
        width: "160px",
        Cell: ({ row }) => (
          <div className="text-center">{row.original.inventory_days}</div>
        ),
      },
      {
        Header: t("Daily sales average value"),
        accessor: "daily_sales_avg_value",
        width: "160px",
        Cell: ({ row }) => (
          <div className="text-center">{"EGP"} {row.original.daily_sales_avg_value?.toFixed(2)}</div>
        ),
      },
      // {
      //   Header: t("Balance Due"),
      //   accessor: "balance_due",
      //   width: "150px",
      //   Cell: ({ row }) => (
      //     <div className="text-start">{"EGP"} {row.original.balance_due}</div>
      //   ),
      // },
      {
        Header: () => (
          <div title={t("Sort")} className="cursor-pointer">
            {t("Balance Due")}
          </div>
        ),
        accessor: "balance_due",
        width: "150px",
        Cell: ({ row }) => (
          <div className="text-start">
            {"EGP"} {row.original.balance_due?.toFixed(2)}
          </div>
        ),
      },

      ...(allStores
        ? [
          {
            Header: t("Store Name"),
            accessor: "store_name",
            width: "200px",
            Cell: ({ row }) => <div className="text-start">{row.original.store_name}</div>,
          },
        ]
        : []),

      {
        Header: () => (
          <div title={t("Sort")} className="cursor-pointer">
            {t("Status")}
          </div>
        ),
        accessor: "pay",
        disableSortBy: true,
        width: "120px",
        Cell: ({ row }) => (
          <div className="text-start">
            {row.original.balance_due !== 0 && (
              <button
                onClick={(e) => {
                  e.stopPropagation(); // Prevent row click
                  handlePaymentClick(row.original); // Call the handlePaymentClick function
                }}
                className="font-semibold w-20 h-8 border rounded-lg bg-[#7EC242] text-white text-sm flex justify-center items-center gap-2"
                type="submit"
              >
                {t("Pay Now")}
              </button>
            )}
            {row.original.balance_due === 0 && (
              <button
                className="font-semibold w-16 h-8 border rounded-lg bg-[#E8A700] text-white text-sm flex justify-center items-center gap-2"
                type="submit"
              >
                {t("Paid")}
              </button>
            )}
          </div>
        ),
      },
      {
                  Header: t("Actions"),
                  disableSortBy: true,
                  accessor: "actions",
                   width: "70px",
                  Cell: ({ row }) => (
                      <div className="flex gap-2 justify-start">
                          <img
                              src={Edit}
                              className="cursor-pointer h-4 w-4"
                              alt="Edit"
                              onClick={(e) => {
                                  e.stopPropagation();
                                  onEditLine(row.original);
                              }}
                          />
                      </div>
                  ),
              },
      {
        Header: "",
        accessor: "action",
        disableSortBy: true,
        width: "100px",
        Cell: ({ row }) => (
          <button
            className="text-[#1b4497] text-start rounded-lg"
            onClick={(e) => {
              e.stopPropagation(); // Prevent row click
              openOrderList(row.original.id);
            }}
          >
            <img
              src={arrowright}
              alt="right"
              className={`${i18n.language === "en" ? "" : "rotate-180"}`}
              height={3}
              width={20}
            />
          </button>
        ),
      },
    ],
    [t, i18n.language, isSelectMode, selectedVendors, allSelected, onSelectAll, onToggleSelect]
  );

  const {
    headerGroups,
    prepareRow,
    page,
    nextPage,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data: data,
      initialState: { pageSize: 10 },
    },
    useSortBy,
    usePagination,
    useRowSelect
  );

  const [pageIndex, setpageIndex] = useState(1);

  useEffect(() => {
    const pageDetails = {
      limit: pageSize,
      offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
    };

    if (pageSize) pagination(pageDetails);
  }, [pageSize, pageIndex]);
  console.log('pageSize==>,', data?.length);

  return (
    <div className="container flex flex-col mx-auto mt-4" style={{ maxWidth: "100%" }}>
      {(loading || (additionalData?.length === 0 && !flag)) ? (
        <div className="h-screen w-[90%] mt-2 ">
          <ShimmerLoader />
        </div>
      ) : (
        <>
          <div
                     style={{
                       overflowY: "auto",
                     }}
                     className=" bg-white"
                   >
                     <table
                       className="font-normal overflow-hidden rounded-lg"
                       style={{
                         tableLayout: "fixed",
                         minWidth: "1400px",
                         width: "100%",
                       }}
                     >
                       <thead className="sticky top-0 z-10">
                         {headerGroups.map((headerGroup, headerIndex) => {
                           const { key: headerKey, ...headerGroupProps } =
                             headerGroup.getHeaderGroupProps();
                           return (
                             <tr
                               key={headerKey}
                               {...headerGroupProps}
                               className="bg-[#78CFEC66] text-sm font-semibold overflow-hidden whitespace-nowrap"
                             >
                               {headerGroup.headers.map((column, colIndex) => {
                                 const { key: columnKey, ...columnProps } =
                                   column.getHeaderProps(
                                     column.getSortByToggleProps(),
                                   );
                                 return (
                                                             <th
  key={columnKey}
  {...columnProps}
  className="py-3 break-words whitespace-normal"
  style={{ width: column.width }}
>
                                    <div className="flex flex-row items-center ms-2 text-sm leading-tight ">
                                                                                                                                                      {column.render("Header")}
                                                                                                                                                      {column.canSort && (
                                                                                                                                                              <span className="ms-1">
                                                                                                                                                        {column.isSorted ? (
                                                                                                                                                          column.isSortedDesc ? (
                                                                                                                                                            <img
                                                                                                                                                              src={Vectorsorting}
                                                                                                                                                              style={{ minHeight: 10, minWidth: 10 }}
                                                                                                                                                              alt="vector"
                                                                                                                                                            />
                                                                                                                                                          ) : (
                                                                                                                                                            <img
                                                                                                                                                              className="rotate-180"
                                                                                                                                                              src={Vectorsorting}
                                                                                                                                                              alt="vector"
                                                                                                                                                            />
                                                                                                                                                          )
                                                                                                                                                        ) : (
                                                                                                                                                          // 👇 Show a neutral icon when column is not sorted
                                                                                                                                                          <img
                                                                                                                                                            src={Vectorsorting}
                                                                                                                                                            alt="sortable"
                                                                                                                                                            style={{ minHeight: 10, minWidth: 10, opacity: 0.3 }}
                                                                                                                                                          />
                                                                                                                                                        )}
                                                                                                                                        
                                                                                                                                                      </span>
                                                                                                                                                      )}
                                                                                                                                                      </div>
                                   </th>
                                 );
                               })}
                             </tr>
                           );
                         })}
                       </thead>
       
                       <tbody className="bg-[#F7F9FD] text-center overflow-hidden">
                         {page.map((row) => {
                           prepareRow(row);
                           return (
                             <React.Fragment key={row.id}>
                               <tr
                                 {...row.getRowProps()}
                                 className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300 fixed-row-height"
                                 onClick={() =>
                                   isSelectMode
                                     ? onToggleSelect && onToggleSelect(row.original.id)
                                     : openOrderList(row.original.id)
                                 }
                               >
                                 {row.cells.map((cell, index) => (
                                   <td
                                     key={index}
                                     {...cell.getCellProps()}
                                     className={`p-2 text-[#272728] h-1212 text-sm font-normal ${index < row.cells.length - 1 ? "relative" : ""} ${cell?.column?.Header == "Product" ? "cursor-pointer" : ""}`}
                                     style={{ width: cell.column.width }}
                                   >
                                     {cell.render("Cell")}
                                   </td>
                                 ))}
                               </tr>
                             </React.Fragment>
                           );
                         })}
                         {page.length === 0 && (
                           <tr>
                             <td colSpan={"100%"}>
                               <Empty
                                 className="mt-10"
                                 description={t("No data available")}
                               />
                             </td>
                           </tr>
                         )}
                       </tbody>
                     </table>
                   </div>

          {/* Pagination */}
          <CustomPagination
            data={data?.length}
            pageIndex={pageIndex}
            pageCount={page?.length}
            canPreviousPage={pageIndex !== 1}
            canNextPage={data?.length === pageSize}
            gotoPage={(page) => nextPage(page)}
            previousPage={() => setpageIndex(pageIndex - 1)}
            nextPage={() => setpageIndex(pageIndex + 1)}
            pageSize={pageSize}
            setPageSize={(size) => setPageSize(size)}
          />
        </>
      )}
    </div>
  );
};

export default AllVendorsTable;
